import { EPartnerActions } from '@/store/partnersStore/PartnerStoreTypes'
import type { PartnerLocales } from '@/types/lang/locales'

export const partnerEn: PartnerLocales = {
    api: {
        error: {
            [EPartnerActions.FETCH_PARTNERS]: 'Error retrieving partners',
            [EPartnerActions.FETCH_PARTNER]: 'Error retrieving the partner',
            [EPartnerActions.ADD_PARTNER]: 'Error adding partner',
            [EPartnerActions.UPDATE_PARTNER]: 'Error modifying partner',
            [EPartnerActions.DELETE_PARTNER]: 'Error when deleting the partner'
        },
        success: {
            [EPartnerActions.FETCH_PARTNERS]: 'Partners retrieved successfully !',
            [EPartnerActions.FETCH_PARTNER]: 'Partner retrieval completed successfully !',
            [EPartnerActions.ADD_PARTNER]: 'Partner added successfully !',
            [EPartnerActions.UPDATE_PARTNER]: 'Partner modified successfully !',
            [EPartnerActions.DELETE_PARTNER]: 'Partner deleted successfully !'
        }
    },
    config: {
        event: 'Event ID',
        checkpoint: 'Checkpoint ID',
        url: 'URL',
        api: 'API'
    },
    line: 'ligne',
    lines: 'lignes',
    total: 'Total'
}
